import { useState } from 'react'
import { Box, Button, Fab, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CloseOutlined } from '@mui/icons-material'
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { FileUploader } from 'react-drag-drop-files'
import { RenderTooltip } from '../../../../components/utilities/RenderTooltip'
import { useCreateKybBatchMutation } from '../../../../services/guenoApi'
import { LoadingButton } from '@mui/lab'

function ModalCreteKybBatch({ setShowCreateBatch, handleCreateBatch }) {
  const { t } = useTranslation(['common', 'messages'])
  const [file, setFile] = useState('')
  const [_, { isLoading }] = useCreateKybBatchMutation({ fixedCacheKey: 'create-kyb-batch' })

  const handleSubmit = async () => {
    handleCreateBatch(file)
  }

  return (
    <Box className="modal" gap="1.5rem">
      <Box className="modal-top">
        <Typography variant="title">{t('common:CREATE_BATCH')}</Typography>
        <Fab variant="close" onClick={() => setShowCreateBatch(false)}>
          <CloseOutlined />
        </Fab>
      </Box>
      <Box className="modal-box-lists" padding="0">
        <Box className="lists-box">
          <Box className="batch-label">
            <Typography variant="title2">{t('common:BATCH_FILES_MODELS')}</Typography>
            <RenderTooltip title={t('common:BATCH_FILES_MODELS_TOOLTIP')} />
          </Box>
          <Box display="flex" flexDirection="row" justifyContent="space-evenly" gap="0.5rem">
            <Button
              variant="outlined"
              onClick={() =>
                window.open(
                  'https://drive.google.com/file/d/1EPAaZ0HkQwl0rNjoaha_zyPitKzKavvH/view?usp=share_link',
                  '_blank',
                  'rel=noopener noreferrer',
                )
              }
              startIcon={<InsertLinkOutlinedIcon />}
              sx={{ paddingInline: '10px' }}
            >
              {t('common:KYB_BATCH')}
            </Button>
          </Box>
        </Box>
        <Box className="lists-box" width="100%">
          <Box className="batch-label">
            <Typography variant="title2">{t('file')}</Typography>
            <RenderTooltip title={t('common:BATCH_FILE_TOOLTIP')} />
          </Box>
          <FileUploader
            handleChange={setFile}
            name="file"
            label={t('common:BATCH_FILE_UPLOADER_LABEL')}
            types={['csv']}
          >
            <Paper
              elevation={0}
              variant="rootDashed"
              className="draggable-main draggable-small"
              sx={{ minHeight: 'auto' }}
            >
              <Box className="draggable-icon" />
              <Typography variant="title2">{t('common:BATCH_FILE_UPLOADER_LABEL')}</Typography>
              <Box>
                <Typography variant="subtitle4">{t('common:or')} </Typography>
                <Typography sx={{ textDecoration: 'underline' }} variant="subtitle4" color="secondary">
                  {t('common:browseMedia')}
                </Typography>
              </Box>
            </Paper>
          </FileUploader>
          <Typography variant="subtitle4">{t('common:supportedMedia')}: CSV.</Typography>
          {file && (
            <Paper elevation={0} variant="colorPrimary" className="onb-file">
              <Box className="onb-file-description">
                <Box className="color-button" sx={{ background: '#E4DDFF' }}>
                  <Typography variant="subtitle1" sx={{ color: '#7E65D5' }}>
                    CSV
                  </Typography>
                </Box>

                <Typography
                  variant="h6"
                  title={file.name}
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                  maxWidth="160px"
                >
                  {file.name}
                </Typography>
              </Box>
              <Box className="onb-file-icons">
                <Button variant="outlinedBlank" onClick={() => setFile('')}>
                  <DeleteOutlineIcon />
                </Button>
              </Box>
            </Paper>
          )}
        </Box>
      </Box>
      <Box className="lists-buttons">
        <LoadingButton
          size="small"
          variant="outlinedGrey"
          onClick={() => setShowCreateBatch(false)}
          loading={isLoading}
        >
          {t('common:cancel')}
        </LoadingButton>
        <LoadingButton
          disabled={isLoading}
          size="small"
          variant="contained"
          type="submit"
          onClick={() => handleSubmit()}
          loading={isLoading}
        >
          {t('common:save')}
        </LoadingButton>
      </Box>
    </Box>
  )
}

export default ModalCreteKybBatch
